import React from "react";
import { Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../base/services/authentication.service";
import { describePaymentGrace } from "./billingActions";
import { useBillingStore } from "./billingStore";
import "./index.scss";

// A payment failed, or waits on the bank, and the grace period still lets the
// organization in: every page of the app's two layouts says so under the top
// bar, until it is settled or the grace period runs out and the routes take the
// organization to the billing page. It watches the billing store, which every
// sign in, refresh and billing call keeps up to date, so it goes as soon as a
// status says the payment went through.
//
// Not on the Subscription page, whose own notice says the same with the fix
// beside it.
const SUBSCRIPTION_PATH = "/subscription-plans";

function PaymentGraceBanner() {
   const { pathname } = useLocation();
   const navigate = useNavigate();
   const organizationId = AuthService.getOrganizationId();
   const status = useBillingStore((state) =>
      organizationId ? state.statuses[organizationId] : undefined
   );
   const canManageBilling = useBillingStore((state) => state.canManageBilling);

   if (pathname.startsWith(SUBSCRIPTION_PATH)) return null;

   const grace = describePaymentGrace(status, canManageBilling);
   if (!grace) return null;

   return (
      <div className="billing-notice billing-notice--warning billing-grace-banner" role="status">
         <div className="billing-notice__text">
            <b>{grace.title}</b>
            <span>{grace.text}</span>
         </div>
         {grace.action && (
            <Button
               className="kapSurveyPrimaryButton"
               onClick={() => navigate(SUBSCRIPTION_PATH)}
            >
               {grace.action}
            </Button>
         )}
      </div>
   );
}

export default PaymentGraceBanner;
